import React, { useContext, useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { PriceType as DomainPriceType } from '@s4l/stayforlong/kernel/PriceType'
import { FiltersContext } from 'client/components/FiltersContainer/context'
import { getDistributionPriceRange, getIsFetching } from 'src/effects/Properties/selectors'
import { useMarket } from 'src/hooks/useMarket'
import { usePrices } from 'src/hooks/usePrices'

import PriceRangeHistogram from 'client/components/PriceRangeHistogram'

import styles from './styles.module.css'

const FilterPrices = () => {
  const intl = useIntl()
  const distributionPriceRange = useSelector(getDistributionPriceRange)
  const isFetching = useSelector(getIsFetching)

  const { currency, market } = useMarket()
  const { filters, setFilters } = useContext(FiltersContext)
  const { priceType: appPriceType } = usePrices({ rooms: [] })

  const domainPriceType = useMemo(
    () => DomainPriceType.createOrUndefinedFromCookie({ value: appPriceType }),
    [appPriceType]
  )

  function onRangeChange(minPrice: string, maxPrice: string) {
    setFilters({ ...filters, minPrice, maxPrice })
  }

  const currencySymbol = useMemo(() => {
    const symbol = intl
      .formatNumber(0, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, '')
      .trim()

    if (market === 'au') {
      return symbol.replace(/(A|AU)?\$/, 'AU$')
    }

    if (market === 'ca') {
      return symbol.replace(/(CA)?\$/, 'CA$')
    }

    if (market === 'no') {
      return symbol.replace(/kr/, currency)
    }

    return symbol
  }, [currency, market, intl])

  const min = filters.minPrice ? +filters.minPrice : undefined
  const max = filters.maxPrice ? +filters.maxPrice : undefined

  const titleMessageKey = domainPriceType?.isFeaturedPriceTotal()
    ? 'global.total-price'
    : 'global.price-per-night'

  return (
    <div className={styles.filterPricesBase} data-testid="filter-price">
      <h3 className={styles.title}>
        <FormattedMessage id={titleMessageKey} />
        {` (${currencySymbol})`}
      </h3>

      <PriceRangeHistogram
        isLoading={isFetching}
        min={min}
        max={max}
        distribution={distributionPriceRange}
        onChange={onRangeChange}
      />
    </div>
  )
}

export default FilterPrices
